import {
  IndexFilters,
  // useSetIndexFiltersMode,
  ChoiceList,
  Tooltip,
  Button,

} from '@shopify/polaris';
import { useEffect } from 'react';

import { useState, useCallback } from 'react';
import Langauge from '../../i18n/Language';
const t = Langauge;

const TableFilters = (props) => {
  // const [isSetText, setIsSetText] = useState(0);
  const {
    loading,
    queryValue,
    setSelectedTabsIndex,
    setQueryValue,
    itemStrings,
    typeSelected,
    isShowFilters,
    setIssueTypeChange,
    productStatusData,
    blogVisibleData,
    issueListData,
    isDisabledQuery,
    isDiyTitle,
    scoreListData,
    isOnpage,
    seoScoreSel,
    custom,
    searchTip,
    pageFilter,
    categoryList,
    pageStatusList,
    focusKeywordListData,
    optStatusListData,
    productStatusListData,
    searchMode,
    resetParams,
    competitorList,
    originWebsite,
    tabMode,
    sortOptions,
    opt_status,
    shopify_status,
    onpage_ProductStatus,
    issueValueSel,
    blogVisibleSel,
    // FAQ / How-To schema 筛选 (对应后端 hasFaq / hasHowto)
    faqSchemaSel,
    howtoSchemaSel,
    // Product Tag 多选筛选 (对应后端 productTags[]); 候选来自 userComboByCard.productTags
    productTagListData,
    productTagSel,

    handleSetMode,
    setSeoScoreChange,
    setCategoryTypeChange,
    setPageStatusChange,
    setFocusKeywordChange,
    handleCompetitorChange,
    setOptStatusChange,
    setProductStatusChange,
    setOnpageProductStatusChange,
    setOnpageBlogVisibleChange,
    // FAQ / How-To schema 筛选回调 (对应后端 hasFaq / hasHowto)
    setFaqSchemaChange,
    setHowtoSchemaChange,
    // Product Tag 多选筛选回调 (对应后端 productTags[])
    setProductTagChange,

  } = props;

  // FAQ / How-To schema 筛选候选值 (对应后端 hasFaq / hasHowto: 1 有 / 0 无)
  const faqSchemaChoices = [
    { label: t("Has FAQ schema"), value: 1 },
    { label: t("No FAQ schema"), value: 0 },
  ];
  const howtoSchemaChoices = [
    { label: t("Has Howto schema"), value: 1 },
    { label: t("No Howto schema"), value: 0 },
  ];
  // Product Tag 候选 (标签原文即值, 后端 productTags[] 精确匹配)
  const productTagChoices = (productTagListData || []).map((tag) => ({ label: tag, value: tag }));

  // 分类排序
  const [sortSelected, setSortSelected] = useState(['']);
  const [selected, setSelected] = useState(0);
  const [seoScore, setSeoScore] = useState([]); // 分数 过滤条件
  const [focusKeyword, setFocusKeyword] = useState([]); // 关键词 过滤条件
  const [mode, setMode] = useState('DEFAULT'); // DEFAULT || FILTERING 


  // 标题
  const tabs = itemStrings.map((item, index) => ({
    content: Boolean(custom) && mode === 'DEFAULT' ? <Tooltip content={t(item.desc)}>
      <label>{t(item.title)}</label>
    </Tooltip> : (Boolean(custom) ? t(item.title) : t(item)),
    index,
    onAction: () => { },
    id: `${item}-${index}`,
    isLocked: 1,
    actions: [],
  }));
  const onCreateNewView = async (value) => {
    return value;
  };

  // 分类 排序
  const handleSortSelected = (e) => {
    setSortSelected(e)
  }

  // Onpage 产品状态
  const [onpageProductStatus, setOnpageProductStatus] = useState([]);
  const handleOnpageProductStatusChange = useCallback(
    (value) => {
      setOnpageProductStatus(value)
      setOnpageProductStatusChange(value)
    },
    [],
  );

  // Onpage 博客可见状态
  const [blogVisibleStatus, setBlogVisibleStatus] = useState([]);
  const handleBlogVisibleChange = useCallback(
    (value) => {
      setBlogVisibleStatus(value)
      setOnpageBlogVisibleChange(value)
    },
    [],
  );

  // 图片压缩页面
  // 优化状态
  const [optStatus, setOptStatus] = useState([]);
  const handleOptStatusChange = useCallback(
    (value) => {
      setOptStatus(value)
      setOptStatusChange(value)
    },
    [],
  );
  const handleOptStatusRemove = () => {
    setOptStatus([]);
    setOptStatusChange([]);
  };
  // 产品状态
  const [productStatus, setProductStatus] = useState([]);
  const handleProductStatusChange = useCallback(
    (value) => {
      setProductStatus(value)
      setProductStatusChange(value)
    },
    [],
  );
  const handleProductStatusRemove = () => {
    setProductStatus([]);
    setProductStatusChange([]);
  };

  // 选择对应条件过滤
  const [issueType, setIssueType] = useState([]);
  const handleIssueTypeChange = useCallback(
    (value) => {
      setIssueType(value)
      setIssueTypeChange(value)
    },
    [],
  );

  // FAQ schema 筛选 (Has FAQ schema / No FAQ schema)
  const [faqSchema, setFaqSchema] = useState([]);
  const handleFaqSchemaChange = useCallback(
    (value) => {
      setFaqSchema(value)
      if (setFaqSchemaChange) {
        setFaqSchemaChange(value)
      }
    },
    [],
  );
  const handleFaqSchemaRemove = useCallback(() => {
    setFaqSchema([])
    if (setFaqSchemaChange) {
      setFaqSchemaChange(-1)
    }
  }, []);

  // How-To schema 筛选 (Has Howto schema / No Howto schema)
  const [howtoSchema, setHowtoSchema] = useState([]);
  const handleHowtoSchemaChange = useCallback(
    (value) => {
      setHowtoSchema(value)
      if (setHowtoSchemaChange) {
        setHowtoSchemaChange(value)
      }
    },
    [],
  );
  const handleHowtoSchemaRemove = useCallback(() => {
    setHowtoSchema([])
    if (setHowtoSchemaChange) {
      setHowtoSchemaChange(-1)
    }
  }, []);

  // Product Tag 多选筛选 (对应后端 productTags[])
  const [productTag, setProductTag] = useState([]);
  const handleProductTagChange = useCallback(
    (value) => {
      setProductTag(value)
      if (setProductTagChange) {
        setProductTagChange(value)
      }
    },
    [],
  );
  const handleProductTagRemove = useCallback(() => {
    setProductTag([])
    if (setProductTagChange) {
      setProductTagChange(-1)
    }
  }, []);
  // Product Tag 分批渲染: 默认展示 50 个, 点击"加载更多"每次追加 50 个
  const PRODUCT_TAG_PAGE_SIZE = 50;
  const [productTagVisibleCount, setProductTagVisibleCount] = useState(PRODUCT_TAG_PAGE_SIZE);
  const handleLoadMoreProductTag = useCallback(() => {
    setProductTagVisibleCount((c) => c + PRODUCT_TAG_PAGE_SIZE);
  }, []);

  // 选择对应条件过滤
  const [categoryType, setCategoryType] = useState([]); // 筛选分类
  const handleCategoryTypeChange = useCallback(
    (value) => {
      setCategoryType(value)
      setCategoryTypeChange(value)
    },
    [],
  );
  const handleCategoryRemove = (state = 0) => {
    setCategoryType([]);
    if (state === 1) {
      setCategoryTypeChange([], -1);
    } else {
      setCategoryTypeChange([]);
    }
  };

  // 页面类型 关键词
  const [pageStatusType, setPageStatusType] = useState([]); // 筛选分类
  const handlePageStatusChange = useCallback(
    (value) => {
      setPageStatusType(value)
      setPageStatusChange(value)
    },
    [],
  );
  const handlePageStatusRemove = (state = 0) => {
    setPageStatusType([]);
    if (state === 1) {
      setPageStatusChange(-1);
    } else {
      setPageStatusChange([]);
    }
  };


  // 输入搜索内容
  const handleQueryValueChange = useCallback(
    (value) => {
      setQueryValue(value); // 传递父亲 设置value
    },
    [],
  );

  // 清空
  const clearQueryValueChange = () => {
    setQueryValue(''); // 传递父亲 设置value
  }

  // Onpage 产品状态
  const handleOnpageProductStatusRemove = useCallback(() => {
    setOnpageProductStatus([]);
    setOnpageProductStatusChange(-1)
  }, []);

  // Onpage 博客可见状态
  const handleBlogVisibleRemove = useCallback(() => {
    setBlogVisibleStatus([]);
    setOnpageBlogVisibleChange(-1)
  }, []);

  // 单独删除对应过滤条件
  const handleIssueTypeRemove = useCallback(() => {
    setIssueType([])
    if (setIssueTypeChange) {
      setIssueTypeChange(-1)
    }
  }, []);

  // 选中分数条件
  const handleSEOScoreChange = (val) => {
    setSeoScore(val);
    setSeoScoreChange(val);
  };
  const handleSEOScoreRemove = () => {
    setSeoScore([]);
    setSeoScoreChange(-1);
  };

  // 选择关键词条件
  const handleFocusKeywordChange = (val) => {
    setFocusKeyword(val);
    setFocusKeywordChange(val);
  };
  const handleFocusKeywordRemove = () => {
    setFocusKeyword([]);
    setFocusKeywordChange(-1);
  };


  // 删除搜索内容
  const handleQueryValueRemove = useCallback(() => setQueryValue(''), []);

  // 清除过滤条件
  const handleFiltersClearAll = useCallback(() => {
    handleQueryValueRemove();
    handleIssueTypeRemove();
    // onpage 独有
    if (isOnpage) {
      handleSEOScoreRemove();
      handleFocusKeywordRemove();
      handleOnpageProductStatusRemove();
      handleBlogVisibleRemove();
      handleFaqSchemaRemove();
      handleHowtoSchemaRemove();
      handleProductTagRemove();
    }

    // 关键词对比
    if (['keywordGap', 'MyWebKeywords'].indexOf(pageFilter) > -1) {
      handleCategoryRemove(1);
      if (['keywordGap'].indexOf(pageFilter) > -1) {
        handleCompetitorChange([]);
      }
    }

    // 关键词 页面状态
    if (['MyWebKeywords'].indexOf(pageFilter) > -1) {
      handlePageStatusRemove(1);
    }

    // 图片压缩 - 手动设置
    if (pageFilter === 'ManuallyImgOpt') {
      handleOptStatusRemove();
      handleProductStatusRemove();
    }
  }, [
    handleQueryValueRemove,
    handleIssueTypeRemove,
    handleSEOScoreRemove,
    handleBlogVisibleRemove,
    handleCategoryRemove,
    handlePageStatusRemove,
    handleFocusKeywordRemove,
    handleOptStatusRemove,
    handleProductStatusRemove,
    handleOnpageProductStatusRemove,
    handleFaqSchemaRemove,
    handleHowtoSchemaRemove,
    handleProductTagRemove,
  ]);

  const onpageFilters = [
    ...(issueListData && issueListData.length > 0 ? [{
      key: 'issueType',
      label: Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category"),
      filter: (
        <ChoiceList
          title={Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category")}
          titleHidden
          choices={issueListData}
          selected={issueType || []}
          onChange={handleIssueTypeChange}
        />
      ),
      shortcut: true,
    }] : []),
    {
      key: 'seoScore',
      label: t("SEO Score"),
      filter: (
        <ChoiceList
          title={t("SEO Score")}
          titleHidden
          choices={scoreListData}
          selected={seoScore || []}
          onChange={handleSEOScoreChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
    {
      key: 'focusKeyword',
      label: t("Primary keyword"),
      filter: (
        <ChoiceList
          title={t("Primary keyword")}
          titleHidden
          choices={focusKeywordListData}
          selected={focusKeyword || []}
          onChange={handleFocusKeywordChange}
        />
      ),
      shortcut: true,
    },
    // FAQ schema 筛选 (所有 onpage tab 均可用)
    {
      key: 'faqSchema',
      label: t("FAQ schema"),
      filter: (
        <ChoiceList
          title={t("FAQ schema")}
          titleHidden
          choices={faqSchemaChoices}
          selected={faqSchema || []}
          onChange={handleFaqSchemaChange}
        />
      ),
      shortcut: true,
    },
  ]

  // How-To schema 筛选 (仅 Blog / Other Pages tab 可用)
  const howtoSchemaFilter = [
    {
      key: 'howtoSchema',
      label: t("Howto schema"),
      filter: (
        <ChoiceList
          title={t("Howto schema")}
          titleHidden
          choices={howtoSchemaChoices}
          selected={howtoSchema || []}
          onChange={handleHowtoSchemaChange}
        />
      ),
      shortcut: true,
    },
  ]


  // Product Tag 多选筛选 (仅 Products tab, 放在筛选列表最下面)
  // 分批渲染: 默认 50 个, 点击"加载更多"追加; 已选中的标签始终保留在可选项中, 避免被截断
  const visibleProductTagChoices = productTagChoices.slice(0, productTagVisibleCount);
  const selectedProductTagChoices = productTagChoices.filter(
    (c) => (productTag || []).includes(c.value) && !visibleProductTagChoices.some((v) => v.value === c.value)
  );
  const renderedProductTagChoices = [...visibleProductTagChoices, ...selectedProductTagChoices];
  const hasMoreProductTag = productTagChoices.length > renderedProductTagChoices.length;
  const productTagFilter = productTagChoices.length > 0 ? [{
    key: 'productTag',
    label: t("Product Tag"),
    filter: (
      <div>
        <ChoiceList
          title={t("Product Tag")}
          titleHidden
          choices={renderedProductTagChoices}
          selected={productTag || []}
          onChange={handleProductTagChange}
          allowMultiple
        />
        {hasMoreProductTag && (
          <div style={{ marginTop: 8 }}>
            <Button variant="plain" onClick={handleLoadMoreProductTag}>
              {t("Load more")}
            </Button>
          </div>
        )}
      </div>
    ),
    shortcut: true,
  }] : [];

  const filters = isOnpage ? (
    selected === 0 ? [
      {
        key: 'Statuses',
        label: t("Product Status"),
        filter: (
          <ChoiceList
            title={t("Product Status")}
            titleHidden
            choices={productStatusData}
            selected={onpageProductStatus || []}
            onChange={handleOnpageProductStatusChange}
            allowMultiple
          />
        ),
        shortcut: true,
      },
      ...onpageFilters,
      ...productTagFilter,
    ] : selected === 1 ? [
      {
        key: 'Visibility',
        label: t("Visibility"),
        filter: (
          <ChoiceList
            title={t("Visibility")}
            titleHidden
            choices={blogVisibleData}
            selected={blogVisibleStatus || []}
            onChange={handleBlogVisibleChange}
            allowMultiple={false}
          />
        ),
        shortcut: true,
      },
      ...onpageFilters,
      ...howtoSchemaFilter,
    ] : selected === 4 ? [
      // Other Pages tab: FAQ (公共) + How-To
      ...onpageFilters,
      ...howtoSchemaFilter,
    ] : onpageFilters
  ) : pageFilter === 'keywordGap' ? [
    {
      key: 'Competitors',
      label: t("Competitors"),
      filter: (
        <ChoiceList
          title={t("Competitors")}
          titleHidden
          choices={competitorList}
          selected={originWebsite || []}
          onChange={handleCompetitorChange}
          allowMultiple
        />
      ),
      shortcut: true,
      pinned: true,
    },
    {
      key: 'categoryType',
      label: t("Category"),
      filter: (
        <ChoiceList
          title={t("Category")}
          titleHidden
          choices={categoryList}
          selected={categoryType || []}
          onChange={handleCategoryTypeChange}
        />
      ),
      shortcut: true,
    }
  ] : pageFilter === 'MyWebKeywords' ? [
    {
      key: 'categoryType',
      label: t("Page Type"),
      filter: (
        <ChoiceList
          title={t("Page Type")}
          titleHidden
          choices={categoryList}
          selected={categoryType || []}
          onChange={handleCategoryTypeChange}
        />
      ),
      shortcut: true,
    },
    {
      key: 'pageStatusType',
      label: t("Page Status"),
      filter: (
        <ChoiceList
          title={t("Page Status")}
          titleHidden
          choices={pageStatusList}
          selected={pageStatusType || []}
          onChange={handlePageStatusChange}
        />
      ),
      shortcut: true,
    }
  ] : pageFilter === 'ManuallyImgOpt' ? [
    {
      key: 'OptStatus',
      label: t("Optimized Status"),
      filter: (
        <ChoiceList
          title={t("Optimized Status")}
          titleHidden
          choices={optStatusListData}
          selected={optStatus || []}
          onChange={handleOptStatusChange}
        />
      ),
      shortcut: true,
      pinned: true,

    },
    ...(typeSelected === 0 ? [{
      key: 'ProductStatus',
      label: t("Product Status"),
      filter: (
        <ChoiceList
          title={t("Product Status")}
          titleHidden
          choices={productStatusListData}
          selected={productStatus || []}
          onChange={handleProductStatusChange}
          allowMultiple
        />
      ),
      shortcut: true,
      pinned: true,
    }] : [])
  ] : [
    {
      key: 'issueType',
      label: Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category"),
      filter: (
        <ChoiceList
          title={Boolean(isDiyTitle) ? t(isDiyTitle) : t("Issue Category")}
          titleHidden
          choices={issueListData}
          selected={issueType || []}
          onChange={handleIssueTypeChange}
        />
      ),
      shortcut: true,
    }
  ];
  const appliedFilters = [];
  if (onpageProductStatus && !isEmpty(onpageProductStatus)) {
    const key = 'Statuses';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, onpageProductStatus),
      onRemove: handleOnpageProductStatusRemove,
    });
  }
  if (blogVisibleStatus && !isEmpty(blogVisibleStatus)) {
    const key = 'Visibility';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, blogVisibleStatus),
      onRemove: handleBlogVisibleRemove,
    });
  }
  if (issueType && !isEmpty(issueType)) {
    const key = 'issueType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, issueType),
      onRemove: handleIssueTypeRemove,
    });
  }
  if (seoScore && !isEmpty(seoScore)) {
    const key = 'seoScore';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, seoScore),
      onRemove: handleSEOScoreRemove,
    });
  }
  if (focusKeyword && !isEmpty(focusKeyword)) {
    const key = 'focusKeyword';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, focusKeyword),
      onRemove: handleFocusKeywordRemove,
    });
  }
  if (faqSchema && !isEmpty(faqSchema)) {
    const key = 'faqSchema';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, faqSchema),
      onRemove: handleFaqSchemaRemove,
    });
  }
  if (howtoSchema && !isEmpty(howtoSchema)) {
    const key = 'howtoSchema';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, howtoSchema),
      onRemove: handleHowtoSchemaRemove,
    });
  }
  if (productTag && !isEmpty(productTag)) {
    const key = 'productTag';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, productTag),
      onRemove: handleProductTagRemove,
    });
  }
  if (originWebsite && !isEmpty(originWebsite)) {
    const key = 'Competitors';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, originWebsite),
      onRemove: () => handleCompetitorChange([]),
    });
  }
  if (categoryType && !isEmpty(categoryType)) {
    const key = 'categoryType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, categoryType),
      onRemove: handleCategoryRemove,
    });
  }
  if (pageStatusType && !isEmpty(pageStatusType)) {
    const key = 'pageStatusType';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, pageStatusType),
      onRemove: handlePageStatusRemove,
    });
  }
  if (optStatus && !isEmpty(optStatus)) {
    const key = 'OptStatus';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, optStatus),
      onRemove: handleOptStatusRemove,
    });
  }
  if (productStatus && !isEmpty(productStatus)) {
    const key = 'ProductStatus';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, productStatus),
      onRemove: handleProductStatusRemove,
    });
  }

  // 选择tab
  const setSelectedTabs = (e) => {
    setSelected(e);
    setSelectedTabsIndex(e);
  }

  const onHandleCancel = () => {
    if (queryValue !== '' || issueType.length > 0 || seoScore.length > 0 || categoryType.length > 0 || focusKeyword.length > 0 || optStatus.length > 0 || productStatus.length > 0 || blogVisibleStatus.length > 0 || faqSchema.length > 0 || howtoSchema.length > 0 || productTag.length > 0) {
      handleFiltersClearAll();
    }
  }; // 取消

  useEffect(() => {
    if (Boolean(issueValueSel) && issueValueSel !== -1) {
      setIssueType([issueValueSel]);
    }
  }, [issueValueSel])

  useEffect(() => {
    if (Boolean(blogVisibleSel) && blogVisibleSel !== -1) {
      setBlogVisibleStatus([blogVisibleSel]);
    }
  }, [blogVisibleSel])

  // 外部 (如顶部数据卡片跳转) 传入 FAQ schema 筛选预选值
  // 模式统一由父级 tabMode 驱动, 这里只同步选中值, 避免与 searchMode/tabMode 的 setMode 竞争抖动
  useEffect(() => {
    if (faqSchemaSel === undefined || faqSchemaSel === null || faqSchemaSel === -1 || faqSchemaSel === '') {
      setFaqSchema([]);
    } else {
      setFaqSchema(Array.isArray(faqSchemaSel) ? faqSchemaSel : [faqSchemaSel]);
    }
  }, [faqSchemaSel])

  // 外部传入 How-To schema 筛选预选值
  useEffect(() => {
    if (howtoSchemaSel === undefined || howtoSchemaSel === null || howtoSchemaSel === -1 || howtoSchemaSel === '') {
      setHowtoSchema([]);
    } else {
      setHowtoSchema(Array.isArray(howtoSchemaSel) ? howtoSchemaSel : [howtoSchemaSel]);
    }
  }, [howtoSchemaSel])

  // 外部传入 Product Tag 筛选预选值
  useEffect(() => {
    if (productTagSel === undefined || productTagSel === null || productTagSel === -1 || productTagSel === '') {
      setProductTag([]);
    } else {
      setProductTag(Array.isArray(productTagSel) ? productTagSel : [productTagSel]);
    }
  }, [productTagSel])

  // 标签列表变化 (如切换 tab 重新拉取) 时, 重置分批渲染数量为初始 50
  useEffect(() => {
    setProductTagVisibleCount(PRODUCT_TAG_PAGE_SIZE);
  }, [productTagListData])

  useEffect(() => {
    if (window.location.pathname === "/on-page-seo/list") {
      handleIssueTypeRemove();
    }
    if (typeSelected !== undefined) {
      setSelected(typeSelected); // 设置tab
    }
  }, [typeSelected])

  // Onpage 产品状态
  useEffect(() => {
    if (onpage_ProductStatus && !isEmpty(onpage_ProductStatus)) {
      setOnpageProductStatus(onpage_ProductStatus === -1 ? [] : onpage_ProductStatus);
    }
  }, [onpage_ProductStatus])

  // 图片压缩 - 优化状态
  useEffect(() => {
    if (opt_status !== undefined) {
      setOptStatus([opt_status]);
    }
  }, [opt_status])
  useEffect(() => {
    if (shopify_status !== undefined) {
      setProductStatus(shopify_status);
    }
  }, [shopify_status])

  useEffect(() => {
    if (!Boolean(seoScoreSel) || seoScoreSel === -1) {
      setSeoScore([]);
    } else {
      const issuesMap = {
        'Well Done': 0,
        'Need Improve': 1,
        'Important Issued': 2
      };
      let type = seoScoreSel.map(n => issuesMap[n]);
      if (type !== -1) {
        setMode('FILTERING'); // 设置模式
        setSeoScore(type);
      } else {
        setMode('DEFAULT'); // 设置模式
        setSeoScore([]);
      }
    }
  }, [seoScoreSel])

  useEffect(() => {
    if (mode === 'DEFAULT' && (queryValue !== '' || issueType.length > 0 || seoScore.length > 0 || categoryType.length > 0 || focusKeyword.length > 0 || optStatus.length > 0 || productStatus.length > 0 || blogVisibleStatus.length > 0 || faqSchema.length > 0 || howtoSchema.length > 0 || productTag.length > 0)) {
      handleFiltersClearAll();
    }

    if (handleSetMode) {
      handleSetMode(mode);
    }
  }, [mode])

  useEffect(() => {
    // tabMode 为 FILTERING (含 schema/tag 派生筛选) 时不因 searchMode=false 回退 DEFAULT, 避免挂载竞态误清筛选
    if (searchMode) {
      setMode('FILTERING');
    } else if (tabMode !== 'FILTERING') {
      setMode('DEFAULT');
    }
  }, [searchMode])

  useEffect(() => {
    if (tabMode) {
      setMode(tabMode); // 设置模式
    }
  }, [tabMode])

  useEffect(() => {
    if (resetParams?.page) {
      const _r = resetParams;
      // 问题分类
      let _issueCate = Number(_r.selectIssue) >= 0 ? _r.selectIssue : _r.selectedActive === 'Active' ? 99 : -1;
      if (_issueCate !== -1) {
        handleIssueTypeChange([_issueCate]);
      } else {
        handleIssueTypeRemove();
      }
      // seo分数程度
      let _seoScore = _r.selectedOptimize === 'Well Done' ? 0 : _r.selectedOptimize === 'Need Improve' ? 1 : _r.selectedOptimize === 'Important Issued' ? 2 : -1;
      if (_seoScore !== -1) {
        handleSEOScoreChange([_seoScore]);
      } else {
        handleSEOScoreRemove();
      }
      // 关键词
      let _isKeywords = _r.is_keyword === 1 ? 1 : _r.is_keyword === 0 ? 0 : -1;
      if (_isKeywords !== -1) {
        handleFocusKeywordChange([_isKeywords]);
      } else {
        handleFocusKeywordRemove();
      }

      if (_issueCate !== -1 || _seoScore !== -1 || _isKeywords !== -1) {
        setMode('FILTERING');
      } else {
        setMode('DEFAULT');
      }
    }
  }, [resetParams])

  return (
    <IndexFilters
      sortOptions={sortOptions || false}
      sortSelected={sortSelected}
      queryValue={queryValue}
      queryPlaceholder={searchTip || t("Search in all")}
      onQueryChange={handleQueryValueChange}
      onQueryClear={clearQueryValueChange}
      onSort={handleSortSelected}
      primaryAction={false}
      cancelAction={{
        onAction: onHandleCancel,
        disabled: false,
        loading: false,
      }}
      tabs={tabs}
      selected={selected}
      onSelect={setSelectedTabs}
      canCreateNewView={false}
      onCreateNewView={onCreateNewView}
      filters={filters}
      appliedFilters={appliedFilters}
      onClearAll={handleFiltersClearAll}
      mode={mode}
      setMode={setMode}
      loading={loading}
      hideFilters={!isShowFilters || Boolean(isDisabledQuery)}
      filteringAccessibilityTooltip={`${Boolean(isDisabledQuery) ? `${t("Search (F)")}` : (isShowFilters ? `${t("Search and filter (F)")}` : `${t("Search (F)")}`)}`}
      disableQueryField={Boolean(isDisabledQuery)}
      isFlushWhenSticky={true}
      disableStickyMode={true}
      disableKeyboardShortcuts={true}
      autoFocusSearchField={false}
    />
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case 'Statuses':
        let onpageProductStatusTag = productStatusData.filter(i => value.includes(i.value));
        let onpageProductStatusTagText = '';
        onpageProductStatusTag.forEach((c, i) => {
          onpageProductStatusTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
        })
        return `${t("Statuses")}: ${onpageProductStatusTagText}`;
      case 'Visibility':
        let blogVisibleTag = blogVisibleData.filter(i => i.value === value[0]);
        let blogTagText = blogVisibleTag.length > 0 ? blogVisibleTag[0]['label'] : '';
        return `${t("Visibility")}: ${blogTagText}`;
      case 'issueType':
        let tag = issueListData.filter(i => i.value === value[0]);
        let tagText = tag.length > 0 ? tag[0]['label'] : '';
        return `${t("Tag")}: ${tagText}`;
      case 'seoScore':
        let stag = scoreListData.filter(i => value.includes(i.value));
        let stagText = '';
        stag.forEach((c, i) => {
          stagText += (i === (value.length - 1)) ? `${c.label}` : `${c.label}, `;
        })
        return `${t("Tag")}: ${stagText}`;
      case 'focusKeyword':
        let fkeytag = focusKeywordListData.filter(i => i.value === value[0]);
        let fkeyText = fkeytag.length > 0 ? fkeytag[0]['label'] : '';
        return `${t("Tag")}: ${fkeyText}`;
      case 'faqSchema':
        let faqSchemaTag = faqSchemaChoices.filter(i => i.value === value[0]);
        let faqSchemaText = faqSchemaTag.length > 0 ? faqSchemaTag[0]['label'] : '';
        return `${t("FAQ schema")}: ${faqSchemaText}`;
      case 'howtoSchema':
        let howtoSchemaTag = howtoSchemaChoices.filter(i => i.value === value[0]);
        let howtoSchemaText = howtoSchemaTag.length > 0 ? howtoSchemaTag[0]['label'] : '';
        return `${t("Howto schema")}: ${howtoSchemaText}`;
      case 'productTag': {
        const productTags = Array.isArray(value) ? value : [value];
        const maxShow = 3;
        const shownTags = productTags.slice(0, maxShow).join(', ');
        const remaining = productTags.length - maxShow;
        const productTagText = remaining > 0 ? `${shownTags}... +${remaining}` : shownTags;
        return `${t("Product Tag")}: ${productTagText}`;
      }
      case 'Competitors':
        let competitorTag = competitorList.filter(i => value.includes(i.value));
        let competitorTagText = '';
        competitorTag.forEach((c, i) => {
          competitorTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
        })
        return `${t("Competitors is")} ${competitorTagText}`;
      case 'categoryType':
        let categoryTag = categoryList.filter(i => i.value === value[0]);
        let categoryTagText = categoryTag.length > 0 ? categoryTag[0]['label'] : '';
        return `${t("Tag")}: ${categoryTagText}`;
      case 'pageStatusType':
        let pageStatueTag = pageStatusList.filter(i => i.value === value[0]);
        let pageStatusTagText = pageStatueTag.length > 0 ? pageStatueTag[0]['label'] : '';
        return `${t("Tag")}: ${pageStatusTagText}`;
      case 'OptStatus':
        let optStatusTag = optStatusListData.filter(i => i.value === value[0]);
        let optStatusTagText = optStatusTag.length > 0 ? optStatusTag[0]['label'] : '';
        return `${t("Optimized Status")}: ${optStatusTagText}`;
      case 'ProductStatus':
        let productStatusTag = productStatusListData.filter(i => value.includes(i.value));
        let productStatusTagText = '';
        productStatusTag.forEach((c, i) => {
          productStatusTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
        })
        return `${t("Product Status")}: ${productStatusTagText}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === '' || value == null;
    }
  }
}


export default TableFilters;
